import React from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';

export const AboutPage = () => {
    return (
        <div className="min-h-screen flex flex-col bg-gray-50">
            <Header />
            <main className="flex-grow pt-16">
                <div className="max-w-4xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
                    <h1 className="text-3xl font-bold text-gray-900 mb-6">About KeepItSorted</h1>
                    
                    <div className="prose prose-blue max-w-none space-y-8">
                        <p className="text-gray-600 text-lg">
                            KeepItSorted is your personal subscription management assistant, designed to help you take control of your digital subscriptions and recurring payments in an increasingly subscription-based world.
                        </p>

                        <h2 className="text-2xl font-semibold text-gray-900">Our Mission</h2>
                        <p className="text-gray-600">
                            In today's digital age, managing multiple subscriptions can be overwhelming. Our mission is to simplify subscription management, helping you avoid unnecessary expenses and stay on top of your recurring payments.
                        </p>

                        <h2 className="text-2xl font-semibold text-gray-900">Key Features</h2>
                        <ul className="list-disc pl-6 text-gray-600 space-y-2">
                            <li>Centralized dashboard for all your subscriptions</li>
                            <li>Automatic renewal reminders</li>
                            <li>Monthly spending insights and analytics</li>
                            <li>Categorized view of subscriptions</li>
                            <li>Budget tracking and optimization suggestions</li>
                            <li>Secure data storage</li>
                        </ul>

                        <h2 className="text-2xl font-semibold text-gray-900">Why Choose KeepItSorted?</h2>
                        <div className="space-y-4">
                            <p className="text-gray-600">
                                <strong>Save Money:</strong> Identify unused subscriptions and avoid forgotten auto-renewals.
                            </p>
                            <p className="text-gray-600">
                                <strong>Save Time:</strong> No more searching through emails or credit card statements to track your subscriptions.
                            </p>
                            <p className="text-gray-600">
                                <strong>Stay Organized:</strong> Keep all your subscription information in one secure place.
                            </p>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}; 